<template>
  <el-dialog width="550px" :visible.sync="visible" :title="!dataForm.id ? $t('add')+'个人用户' : $t('update')+'个人用户'" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" style="padding-right: 50px;" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" label-width="120px">
      <el-form-item prop="userCode" label="编码">
        <el-input v-model="dataForm.userCode" placeholder="编码" disabled></el-input>
      </el-form-item>
      <el-form-item prop="userType" label="用户类型">
          <el-input  value="个人用户" placeholder="用户类型" disabled></el-input>
      </el-form-item>
      <el-form-item prop="username" label="用户名">
        <el-input v-model="dataForm.username" placeholder="用户名" disabled></el-input>
      </el-form-item>
      <el-form-item prop="password" :label="$t('user.password')" :class="{ 'is-required': !dataForm.id }">
        <el-input v-model="dataForm.password" type="password" :placeholder="$t('user.password')"></el-input>
      </el-form-item>
	  <el-form-item>
	  	<el-checkbox v-model="dataForm.deactivate" true-label="yes" false-label="no">停用</el-checkbox>
	  </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import {isEmail, isMobile, testPassword} from '@/utils/validate'
import aesJs from '../../../utils/login-aes'
let checkPassword = (rule, value, callback) => {
  if(!!value){
    if(!testPassword(value)){
      callback(new Error('请设置8到12位数字，大写、小写字母，符号，至少三种'))
    }
    callback()
  }
  callback()
}
export default {
  data () {

    return {
      visible: false,
      roleList: [],
      roleIdListDefault: [],
      dataForm: {
        id: '',
        userType: 'gryh',
        username: '',
        password: '',
        userCode: '',
        deactivate: 'yes'

      }
    }
  },
  computed: {
    dataRule () {
      return {
		      username: [{ required: true, message: this.$t('validate.required'), trigger: 'blur' }],
          password: [
            { required: false,validator: checkPassword,trigger: 'blur'}
          ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/user/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code != 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
        this.dataForm.deactivate = (res.data.status == 0 ? 'yes' : 'no')
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        let url = '/sys/plat/info/user/update'
        this.dataForm.userId = this.dataForm.id
        let paramsForm = JSON.parse(JSON.stringify(this.dataForm));
        paramsForm.password = aesJs.encrypt(paramsForm.password)
        this.$http.post(url, {
          ...paramsForm
        }).then(({ data: res }) => {
          // this.dataForm.password = aesJs.decrypt(this.dataForm.password)
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>

<style lang="scss" scoped>
.mod-sys__user {
  .dept-list {
    .el-input__inner,
    .el-input__suffix {
      cursor: pointer;
    }
  }
  .role-list {
    .el-select {
      width: 100%;
    }
  }
}
</style>
